import React from 'react';
import { Alert } from 'antd';
import styles from './NotificationAlert.module.less';

type NotificationAlertProps = {
  visible: boolean;
  message: string;
  onClose: () => void;
};

const NotificationAlert: React.FC<NotificationAlertProps> = ({ message, onClose }) => {
  return (
    <Alert message={message} className={styles.customAlert} type="warning" showIcon closable onClose={onClose} />
  );
};

export default NotificationAlert;
